
const fiyatlandirmaTipOptions = [
    {
        value: 0,
        text:"TL/Komple"
      },
      {
        value: 1,
        text:"TL/Ton"
      },
]

export default fiyatlandirmaTipOptions